import { useState } from 'react';

export const useDisabledToggle = (initialValue = false) => {
    const [includeDisabled, setIncludeDisabled] = useState(initialValue);
    
    return {
        includeDisabled,
        setIncludeDisabled,
        toggleIncludeDisabled: () => setIncludeDisabled(!includeDisabled)
    };
};